import {SortDirection} from "../../../data-structures/sort";

export function sortByIds(models:any[], sortedIds:ID[]) {

    return _.orderBy(models, [
        model => sortedIds?.includes(model.id) ? 0 : 1 ,
        model => _.indexOf(sortedIds, model.id)
    ], [
        SortDirection.ASC, SortDirection.ASC
    ])

}